import { createSelector } from "reselect";

const selectTheme = (state) => state.theme;

export const selectThemeDirection = createSelector(
  [selectTheme],
  (theme) => theme.direction
);
